<template>
<div class="pages">
    <router-view/>
</div>
</template>

<style lang="scss" src="@/styles/profile/pages/pages.scss"></style>
